import React from "react";

export const LazyEditor = React.lazy(() =>
    import(/* webpackChunkName: "Editor" */ "./Editor").then(module => ({
        default: module.Editor
    }))
);

export const LazyEditorDisplay = React.lazy(() =>
    import(/* webpackChunkName: "EditorDisplay" */ "./EditorDisplay").then(
        module => ({ default: module.EditorDisplay })
    )
);
